module.exports = __webpack_public_path__ + "static/media/eminique-black.8d0efea5.png";